<div class="body" style="white-space: normal !important;">
    <p class="p-descricao"><b>{{ index + 1 }} - {{ descricaoPergunta }}</b></p>

    <p *ngIf="imgPergunta" class="over-auto">
        <img [src]="imgPergunta" alt="pergunta">
    </p>

    <div (click)="liberarRefazer()">
        <mat-radio-group [(ngModel)]="respondido" (change)="OnResponder()" class="flex flex-column">
            <mat-radio-button *ngFor="let resposta of respostas; let index = index" [value]="resposta" color="primary"
                class="mt-1" [ngClass]="styleResposta(resposta, pergunta)?.class" name="respondidoNameRadio">

                <div class="flex w-100 pd05" [ngClass]="(!respondeu && (index % 2 !== 0)) ? 'bg-grey' : ''">
                    <span class="opcao-resposta"> <b>{{ resposta.opcao }}</b>&nbsp;)&nbsp; </span>
                    <div class="flex flex-column">
                        {{ resposta.descricao }}
                        <img *ngIf="showImgResposta(resposta)" [src]="showImgResposta(resposta)" alt="respostas">
                    </div>
                    <!-- <div class="flex-fill"></div> -->
                    <mat-icon *ngIf="respondeu" class="prl-1-5"
                        [ngClass]="styleResposta(resposta, pergunta)?.iconClass">{{ styleResposta(resposta,
                        pergunta)?.icon }}</mat-icon>
                </div>
                <mat-divider></mat-divider>
            </mat-radio-button>
        </mat-radio-group>
        <div>
            <div class="mt-3"></div>
            <title-line title=""></title-line>
        </div>